export const chartConfig = {
  productivity: {
    chart: {
      theme: "fusion",
      showLegend: 1,
      showValues: 0,
      yAxisTickValues: "-20,0,20,40,60,80,100",
      lineThickness: "6",
      anchorRadius: "8",
      drawAnchors: "1",
      anchorBorderColor: "#3CD221",
      anchorBorderThickness: "2",
      anchorBgColor: "#EDFEEA",
      anchorAlpha: "100",
      paletteColors: "#32CD32",
      trendlineColor: "#0000FF",
      drawGridLine: "1",
      verticalGridLineColor: "#000000",
      verticalGridLineThickness: "1",
    },
    data: [],
    trendlines: [
      {
        line: [
          {
            startvalue: "50",
            color: "#0000FF",
            displayValue: " ",
            dashed: "1",
            dashLen: "4",
            dashGap: "2",
            valueOnRight: "1",
            showOnTop: "1",
          },
        ],
      },
    ],
  },
  modeOfTx: {
    chart: {
      theme: "fusion",
      showLegend: 1,
      legendPosition: "top-left",
      legendAlign: "left",
      showValues: 0,
      yAxisMinValue: "0",
      yAxisMaxValue: "100",
    },
    categories: [],
    dataset: [],
  },
};
